import { useEffect, useState } from 'react';

import { useData } from '../../data/DataContext.tsx';
import { sizedImage } from '../../platform/images.ts';

// Guild pictures for lists built from membership records, which carry only
// the guild's name and role: each guild's own record is read for its picture
// (founder, 5 November 2026: no new membership field). Only the picture: the
// banner stays on the guild page. No picture, or a failed read, leaves the
// letters (Avatar's fallback).
export function useGuildPictures(ids: readonly string[], size = 100): Record<string, string | null> {
  const { guilds } = useData();
  const key = ids.join(',');
  const [pictures, setPictures] = useState<{ key: string; byId: Record<string, string | null> }>({ key: '', byId: {} });
  useEffect(() => {
    if (!key) return;
    let active = true;
    Promise.all(key.split(',').map(id => guilds.guild(id).then(
      guild => [id, guild?.iconUrl ? sizedImage(guild.iconUrl, size) : null] as const,
      () => [id, null] as const,
    ))).then(entries => { if (active) setPictures({ key, byId: Object.fromEntries(entries) }); });
    return () => { active = false; };
  }, [guilds, key, size]);
  return pictures.key === key ? pictures.byId : {};
}
